import { render } from "./pca-grid-ro.vue?vue&type=template&id=71207e91&scoped=true"
import script from "./pca-grid-ro.vue?vue&type=script&setup=true&lang=js"
export * from "./pca-grid-ro.vue?vue&type=script&setup=true&lang=js"

import "./pca-grid-ro.vue?vue&type=style&index=0&id=71207e91&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71207e91"],['__file',"src/views/contracts/print-contract/components/pca-grid-ro.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71207e91"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71207e91', __exports__)) {
    api.reload('71207e91', __exports__)
  }
  
  module.hot.accept("./pca-grid-ro.vue?vue&type=template&id=71207e91&scoped=true", () => {
    api.rerender('71207e91', render)
  })

}


export default __exports__